import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { cssProperty } from '@holmescorp/middleware/css-property';
import css from '../css/completed-viz.m.css';
const factory = create({ theme, cssProperty }).properties();
const num = new Intl.NumberFormat('en', { style: 'decimal', maximumSignificantDigits: 2 });
export const CompletedViz = factory(({ properties, middleware: { theme, cssProperty } }) => {
    const { xqa, percent } = properties();
    const scorePercent = cssProperty.get('root', '--complete-percent');
    if (scorePercent !== num.format(percent)) {
        cssProperty.set('root', '--complete-percent', num.format(percent));
    }
    const themeCss = theme.classes(css);
    return v('div', { key: 'root', xqa, classes: [themeCss.root] }, [
        v('div', { key: 'wrapper', classes: [themeCss.wrapper] }, [
            v('div', { key: 'field', classes: [themeCss.field] }, [v('div', { key: 'bar', classes: [themeCss.bar] })])
        ])
    ]);
});
